import { Directive, HostListener, ElementRef, TemplateRef, Input, OnDestroy, Output, EventEmitter } from "@angular/core";
import { HoverPanelService } from "./hover-panel.service";

@Directive({ selector: "[hoverPanel]",standalone: false })
export class HoverPanelDirective implements OnDestroy {
  @Input() hoverPanelTemplate: TemplateRef<any>;
  @Input() hoverPanelPosition: string = "bottom-left";
  @Input() hoverPanelWidth: number = 300;
  @Input() hoverPanelHeight: number;
  @Input() hoverPanelZIndex: number;
  @Output() hoverPanelClose = new EventEmitter<void>();
  private id: string;
  active: boolean = false;

  constructor(private hp: HoverPanelService, private element: ElementRef) {
    this.hp.getChanges().subscribe((d: any) => {
      if (d === "remove") {
        this.active = false;
      }
    });
  }

  @HostListener("click", ["$event"])
  onClick(e: any) {
    this.create(e);
  }

  create(e: any): void {
    this.id = new Date().getTime().toString();

    if (!this.active) {
      this.destroy();
      this.id = new Date().getTime().toString();

      const d = {
        id: this.id,
        ref: this.element,
        directive: this,
        template: this.hoverPanelTemplate,
        position: this.hoverPanelPosition,
        event: e,
        width: this.hoverPanelWidth + "px",
        height: this.hoverPanelHeight + "px",
        zIndex: this.hoverPanelZIndex || 1000001,
        onClose: this.hoverPanelClose
      };

      if (d.template) {
        setTimeout(() => this.hp.add(d));
        this.active = true;
      }
    } else {
      this.destroy();
      this.active = false;
      this.element.nativeElement.blur();
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    this.hp.remove();
  }
}
